import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../services/API";

export const userReportNews = createAsyncThunk("reportNews", async ({ newsId, data }, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.post(`/neighbor_news/news/${newsId}/report/`, data)
        const result = response.data;
        return result
    } catch (error) {
        if (error.response) {
            // The request was made and the server responded with a status code
            return rejectWithValue(error.response.data);
        }
        else if (error.request) {
            // The request was made but no response was received
            return rejectWithValue("No response from server");
        }
        else {
            // Something happened in setting up the request that triggered an Error
            return rejectWithValue(error.message);
        }
    }
});

export const reportNewsComment = createAsyncThunk("reportNewsComment", async ({ commentId, data }, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.post(`/neighbor_news/report_comment/${commentId}/`, data)
        const result = response.data;
        return result
    } catch (error) {
        if (error.response) {
            // The request was made and the server responded with a status code
            return rejectWithValue(error.response.data);
        }
        else if (error.request) {
            // The request was made but no response was received
            return rejectWithValue("No response from server");
        }
        else {
            // Something happened in setting up the request that triggered an Error
            return rejectWithValue(error.message);
        }
    }
});


export const NeighborhoodNewsReportSlice = createSlice({
    name: "NeighborhoodNews",
    initialState: {
        neighborhoodNewsReport: {},
        loading: false,
        error: null,
    },
    extraReducers: (builder) => {

        builder.addCase(reportNewsComment.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(reportNewsComment.fulfilled, (state, action) => {
            state.loading = false;
            state.neighborhoodNewsReport = action.payload;
        });
        builder.addCase(reportNewsComment.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
        builder.addCase(userReportNews.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(userReportNews.fulfilled, (state, action) => {
            state.loading = false;
            state.neighborhoodNewsReport = action.payload;
        });
        builder.addCase(userReportNews.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

    },
});

export default NeighborhoodNewsReportSlice.reducer;